<template>
  <div class="layout--static pt--100px">
    <div class="login vh--100%">
      <div class="layout--table">
        <div class="layout--table-cell">
          <div class="max-w--400px px--16px m--auto text--left">
            <div class="text--center mb--24px">
              <logo class=""></logo>
            </div>

            <slot></slot>
          </div>
        </div>
        <!--layout--table-cell-->
      </div>
      <!--layout--table-->
    </div>
    <!-- login -->
  </div>
  <!--layout--static-->
</template>

<script>
export default {
  components: {
    Logo: () => import('@/component/common/Logo')
    // FindTab: () => import("@/components/layout/FindTab")
  }
}
</script>
